import { Icon } from '@material-ui/core'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React from 'react'
import PrimaryTheme from '../Themes/Primary'
import PlayStore from "./../images/play-store.svg"
import AppStore from "./../images/app-store.svg"


export default function Banner(props: BannerProps) {
  return (
    <blockquote className={props.className + " animated fadeIn"}>
      <div className="row m-0 justify-content-center align-items-center">
        <div className="col-md-1 p-0 pt-2 text-center">
          {!props.isWalletWithdrawal? (<Icon style={{
            color: props.iconColor
          }}>information</Icon>):
          (<InfoOutlinedIcon style={{
            color: '#296CF0'
          }}></InfoOutlinedIcon>)}
        </div>
        <div className="col"> 
          <p className="mb-0 p-2" 
            style={{
              fontFamily: PrimaryTheme.fonts?.RegularFont
            }}> 
            {props.text}
          </p>
          {props.isWalletWithdrawal && 
            <div className='d-xl-flex'>
              <div>
                <span style={{
                  fontSize: '12px',
                  fontWeight: 600,
                  padding: '7px'
                }}
                  >Get a bankly customer account:</span>
                <div style={{display:'flex'}}>
                  <a style={{padding: '2px 5px'}} href="https://play.google.com/store/apps/details?id=com.bankly.bloomm">
                    <button
                      style={{
                        paddingLeft: "14px",
                        paddingRight: "14px",
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        border: "none",
                        fontSize: PrimaryTheme.fontSizes?.normal,
                        fontWeight: 500,
                        backgroundColor: PrimaryTheme.primary,
                        color: PrimaryTheme.white,
                        borderRadius: "8px",
                      }}
                    >
                      <img style={{width:'16px', marginRight:'5px'}} alt={`Bankly`} src={PlayStore} />
                      Playstore
                    </button>
                  </a>
                  <a style={{padding: '2px 5px'}} href="https://apps.apple.com/ng/app/bankly/id1582452537">
                    <button
                      style={{
                        paddingLeft: "14px",
                        paddingRight: "14px",
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        border: "none",
                        fontSize: PrimaryTheme.fontSizes?.normal,
                        fontWeight: 500,
                        backgroundColor: PrimaryTheme.primary,
                        color: PrimaryTheme.white,
                        borderRadius: "8px",
                      }}
                    >
                      <img style={{width:'16px', marginRight:'5px'}} alt={`Bankly`} src={AppStore} />
                      Appstore
                    </button>
                  </a>

                </div>
              </div>
              {/* <div>
                <span style={{
                  fontSize: '12px',
                  fontWeight: 600,
                  padding: '7px'
                }}
                  >Get a bankly agent account:</span>
                <div style={{display:'flex'}}>
                  <a style={{padding: '2px 5px'}} href="https://play.google.com/store/apps/details?id=ng.bankly.bankly.agent">
                    <button
                      style={{
                        paddingLeft: "14px",
                        paddingRight: "14px",
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        border: "none",
                        fontSize: PrimaryTheme.fontSizes?.normal,
                        fontWeight: 500,
                        backgroundColor: PrimaryTheme.primary,
                        color: PrimaryTheme.white,
                        borderRadius: "8px",
                      }}
                    >
                      <img style={{width:'16px', marginRight:'5px'}} alt={`Bankly`} src={PlayStore} />
                      Playstore
                    </button>
                  </a>
                  <a style={{padding: '2px 5px'}} href="https://apps.apple.com/ng/app/bankly-agent-app/id1533848014">
                    <button
                      style={{
                        paddingLeft: "14px",
                        paddingRight: "14px",
                        paddingTop: '8px',
                        paddingBottom: '8px',
                        border: "none",
                        fontSize: PrimaryTheme.fontSizes?.normal,
                        fontWeight: 500,
                        backgroundColor: PrimaryTheme.primary,
                        color: PrimaryTheme.white,
                        borderRadius: "8px",
                      }}
                    >
                      <img style={{width:'16px', marginRight:'5px'}} alt={`Bankly`} src={AppStore} />
                      Appstore
                    </button>
                  </a>

                </div>
              </div> */}
            </div>
          }
        </div>
      </div>
    </blockquote>
  )
}


interface BannerProps {
  borderColor?: string;
  backgroundColor?: string;
  iconColor?: string;
  text?: string;
  className?: "bq-warning" | "bq-warning2" | "bq-info" | "bq-danger"|"bq-success" | undefined;
  isWalletWithdrawal?: boolean
}